import { all } from "redux-saga/effects";

import {
    getUserInfoWatcher,
    editUserPasswordWatcher
} from "./getUserInfo.saga";
import { logoutWatcher } from "./logout.saga";

export default function* rootSaga() {
    yield all([
        getUserInfoWatcher(),
        logoutWatcher(),
        editUserPasswordWatcher()
    ]);
}
